<template>
  <div class="totalbox">
    <p class="titbox">Booking Summary</p>
    <div class="infobox">
      <div class="pic" :style="'background-image: url(' + odata.trip_thumb + ');'"></div>
      <div class="txt">{{ odata.tripname }}</div>
    </div>
    <div class="listbox">
      <div class="row">
        <p class="label">
          {{ tripType > 1 ? 'Departure' : tripType > 0 ? 'Arrival' : 'Starting' }} City
        </p>
        <p class="contxt">{{ tripcity }}</p>
      </div>
      <div class="row" v-if="tripType == 0">
        <p class="label">Ending City</p>
        <p class="contxt">{{ returncity }}</p>
      </div>
      <div class="row">
        <p class="label">{{ tripType > 1 ? 'From' : 'Tour Starts' }}</p>
        <p class="contxt">{{ flyWeekMDate(odata.depart_date) }}</p>
      </div>
      <div class="row">
        <p class="label">{{ tripType > 1 ? 'To' : 'Tour Ends' }}</p>
        <p class="contxt">{{ flyWeekMDate(getReturnDate(odata)) }}</p>
      </div>
      <div class="row">
        <p class="label">Duration</p>
        <p class="contxt">{{ odata.duration }}</p>
      </div>
      <div class="row">
        <p class="label">Travelers</p>
        <p class="contxt">
          {{ Adults > 0 ? Adults + ' Adult' + (Adults > 1 ? 's' : '') : '' }}
          {{ Child > 0 ? Child + ' Child' + (Child > 1 ? 'ren' : '') : '' }}
        </p>
      </div>
      <div class="row">
        <p class="label">Room Categories</p>
      </div>
      <template v-for="(room, idx) in roomlist">
        <div class="row">
          <template v-for="item in room.bedrooms">
            <template v-if="item.option_value_id == room.selectedbedroom">
              <p class="contxt">{{ item.name }}</p>
              <p class="contxt">X1</p>
            </template>
          </template>
        </div>
      </template>
    </div>
  </div>
</template>
<script>
import { notEmpty } from '@/utils/tool.js'
import { localDriver } from '@/utils/localDriver'

export default {
  props: ['step', 'rmkey', 'odkey'],
  data() {
    return {
      pressnum: 2,
      ismobile: false,
      odata: {},
      roomlist: {},
      Adults: 0,
      Child: 0,
      tripcity: '',
      tripType: 0,
      returncity: '',
      nights: ''
    }
  },
  watch: {},
  mounted() {
    this.ismobile = document.documentElement.clientWidth < 750
    this.initData()
  },
  methods: {
    async initData() {
      if (this.odkey == '') {
        return false
      }
      //console.log('----Trip Summmary-000--',[this.odkey,this.rmkey]);
      this.odata = await localDriver.getItem(this.odkey)
      this.roomlist = await localDriver.getItem(this.rmkey)
      this.tripType =
          this.odata.product_info.model.toUpperCase().slice(0, 3) === 'FP-' ? 2 : this.odata.isFlight
        if (this.tripType == 2) {
          this.tripcity =
            this.odata && this.odata.selectedCity
              ? 'spot' in this.odata.selectedCity
                ? this.odata.selectedCity.spot
                : this.odata.selectedCity.name
              : ''
        } else {
          this.tripcity = this.odata.alldays[0].cityname
        }
        this.returncity = this.odata.alldays[this.odata.alldays.length - 1].cityname
        this.nights =
          this.odata.product_info.nights > 0
            ? this.odata.product_info.nights +
              ' Night' +
              (this.odata.product_info.nights > 1 ? 's' : '')
            : ''
        for (let i in this.roomlist) {
          this.Adults += parseInt(this.roomlist[i].Adults)
          this.Child += parseInt(this.roomlist[i].Child)
        }
    },
    flyWeekMDate(d, y = 1) {
      var dt = new Date((notEmpty(d) ? d.slice(0, 10) : d) + 'T00:00:01')
      var weeks = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat']
      var months = [
        'Jan',
        'Feb',
        'Mar',
        'Apr',
        'May',
        'Jun',
        'Jul',
        'Aug',
        'Sep',
        'Oct',
        'Nov',
        'Dec'
      ]
      var formattedDate =
        weeks[dt.getDay()] +
        ', ' +
        months[dt.getMonth()] +
        ' ' +
        dt.getDate() +
        ',' +
        (y > 0 ? ' ' + dt.getFullYear() : '')
      return formattedDate
    },
    getReturnDate(d) {
      return d && d.depart_date
        ? new Date(d.depart_date + 'T00:00:01')
            .nextDate(parseInt(d.alldays.length) - 1)
            .getFullstring()
        : ''
    }
  }
}
</script>

<style scope>
.totalbox {
  padding: 0 2.4rem;
  border-radius: 1.2rem;
  margin-bottom: 2.4rem;
  background: #fff;
}
.totalbox .titbox {
  padding-top: 2rem;
  color: #333;
  font-family: Poppins-Bold;
  font-size: 1.6rem;
  font-weight: 700;
  line-height: 2.2rem;
}
.totalbox .infobox {
  padding: 1.6rem 0 2.4rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid #eaeaea;
}
.totalbox .infobox .pic {
  width: 8rem;
  height: 7rem;
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  border-radius: 0.8rem;
}
.totalbox .infobox .txt {
  width: calc(100% - 9.2rem);
  font-family: Poppins;
  font-size: 1.4rem;
  font-weight: 500;
  line-height: 2rem;
  text-align: left;
}
.totalbox .listbox {
  padding: 1.2rem 0;
  border-bottom: 1px solid #eaeaea;
}
.totalbox .listbox:last-child {
  border-bottom: 0;
}
.totalbox .listbox .tit {
  font-family: Poppins-Bold;
  font-size: 1.4rem;
  font-weight: 700;
  line-height: 2rem;
  padding: 0.8rem 0;
}
.totalbox .listbox .row {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  font-family: Poppins;
  font-size: 1.4rem;
  font-weight: 500;
  line-height: 2rem;
  padding: 0.8rem 0;
}
.totalbox .listbox .row.total {
  font-size: 1.6rem;
  font-family: Poppins-Bold;
  font-weight: 700;
}
.totalbox .listbox .row .label {
  color: #666666;
}
.totalbox .listbox .row .airico {
  width: 2rem;
  display: block;
}
.totalbox .listbox .row.total .label,
.totalbox .listbox .row .label span.black,
.totalbox .listbox .row .contxt {
  color: #333333;
}
.totalbox .listbox .row .green {
  color: #4f6f52 !important;
}

/* 移动端  */
@media screen and (max-width: 750px) {
}
</style>
